import { IconButton, Modal } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useEffect } from "react";
import { useState } from "react";
import LoadingComponent from "../loading";
import { Close as CloseIcon } from "@material-ui/icons";
import { closeImage } from "../../redux/app";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: "relative",
    },
    content: { height: "100%" },
    closeBtn: {
      position: "absolute",
      top: 16,
      left: 16,
      backdropFilter: "blur(10px)",
      color: "#fff",
      background: "#fff5",
    },
    imageWrapper: {
      height: "100%",
      "& img": {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        outline: "none",
      },
    },
  })
);
export default function ImageViewer() {
  const { imageViewerUrl: url } = useSelector((s) => s.app);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
  }, [url]);

  useEffect(
    () => close(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function close() {
    dispatch(closeImage());
  }
  return (
    <Modal open={!!url} onClose={close} className={classes.root}>
      <div className={classes.content}>
        <IconButton className={classes.closeBtn} onClick={close}>
          <CloseIcon />
        </IconButton>
        <div className={classes.imageWrapper}>
          <LoadingComponent overlay loading={loading}>
            <img onLoad={() => setLoading(false)} src={url || ""} alt="" />
          </LoadingComponent>
        </div>
      </div>
    </Modal>
  );
}
